import { request } from './api';

class UsersService {
  // Buscar todos os usuários
  async getUsers() {
    try {
      const response = await request('/api/users');
      return response;
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      throw error;
    }
  }

  // Buscar usuário por ID
  async getUserById(id) {
    try {
      const response = await request(`/api/users/${id}`);
      return response;
    } catch (error) {
      console.error('Erro ao buscar usuário:', error);
      throw error;
    }
  }

  // Criar novo usuário
  async createUser(userData) {
    try {
      const response = await request('/api/users', {
        method: 'POST',
        body: userData
      });
      return response;
    } catch (error) {
      console.error('Erro ao criar usuário:', error);
      throw error;
    }
  }

  // Atualizar usuário
  async updateUser(id, userData) {
    try {
      const response = await request(`/api/users/${id}`, {
        method: 'PUT',
        body: userData
      });
      return response;
    } catch (error) {
      console.error('Erro ao atualizar usuário:', error);
      throw error;
    }
  }

  // Deletar usuário
  async deleteUser(id) {
    try {
      const response = await request(`/api/users/${id}`, {
        method: 'DELETE'
      });
      return response;
    } catch (error) {
      console.error('Erro ao deletar usuário:', error);
      throw error;
    }
  }

  // Alterar status do usuário
  async toggleUserStatus(id, active) {
    try {
      const response = await request(`/api/users/${id}/status`, {
        method: 'PATCH',
        body: { active }
      });
      return response;
    } catch (error) {
      console.error('Erro ao alterar status do usuário:', error);
      throw error;
    }
  }

  // Atribuir filas ao usuário
  async assignQueues(userId, queueIds) {
    try {
      const response = await request(`/api/users/${userId}/queues`, {
        method: 'POST',
        body: { queueIds }
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

const usersService = new UsersService();
export default usersService;
